import { FlagsPage } from "fleet/view/flags/flags-page";
import { connect } from "react-redux";
import { createPromiseApiAction } from "redux-store/api-sagas";
import { getAuthUser } from "redux-store/auth/selectors";
import { EDIT_DEVICE_FLAGS } from "redux-store/devices/actions";
import { EDIT_NETWORK_FLAGS } from "redux-store/networks/actions";
import { networksSelector } from "redux-store/networks/selectors";
import { isReadonly } from "redux-store/users/selectors";
import { storesReady } from "redux-store/utils";
import * as FeatureFlags from 'redux-store/feature-flags/selectors';

function mapStateToProps(state, props) {
  const { id } = props.match.params || {};

  const storesLoaded = storesReady(state.global.networks);
  const networks = networksSelector(state);
  const network = networks[id] ? networks[id] : {};
  const user = getAuthUser(state);
  const readonly = isReadonly(user);
  const featureFlags = FeatureFlags.getFeatureFlags(state);

  return {
    readonly,
    storesLoaded,
    model: network,
    type: "network",
    featureFlags: featureFlags,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateDeviceFlags: (serviceArgs) => {
      return createPromiseApiAction(dispatch, EDIT_DEVICE_FLAGS, [
        serviceArgs.id,
        serviceArgs.flags,
      ]);
    },
    updateNetworkFlags: (serviceArgs) => {
      return createPromiseApiAction(dispatch, EDIT_NETWORK_FLAGS, [
        serviceArgs.id,
        serviceArgs.flags,
      ]);
    },
  };
}

const ConnectedNetworkFlagsPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FlagsPage);

export { ConnectedNetworkFlagsPage };
